import { render, staticRenderFns } from "./listCupones.vue?vue&type=template&id=58aaba21&scoped=true"
import script from "./listCupones.vue?vue&type=script&lang=js"
export * from "./listCupones.vue?vue&type=script&lang=js"
import style0 from "./listCupones.vue?vue&type=style&index=0&id=58aaba21&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58aaba21",
  null
  
)

export default component.exports